import { ReportData } from '../../model/reportData';
import moment from 'moment';

export type Order = 'asc' | 'desc';

export function sortReportByField<Key extends keyof ReportData>(
  order: Order,
  orderBy: Key
): (a: ReportData, b: ReportData) => number {
  return order === 'desc'
    ? (a, b) => sortRecord(a, b, orderBy)
    : (a, b) => -sortRecord(a, b, orderBy);
}

function sortRecord<ReportData>(
  a: ReportData,
  b: ReportData,
  orderBy: keyof ReportData
) {
  let reportField = orderBy as string;
  if (reportField === 'lastPictureDay' || reportField === 'firstPictureDay' || reportField === 'uploadDate' || reportField === 'eventScheduledDate') {
    let date1 = a[orderBy] as unknown as string;
    let date2 = b[orderBy] as unknown as string;
    return compareDates(date1, date2);
  }
  if (reportField === 'photographyEndTime' || reportField === 'emCompleteDate' || reportField === 'startTime') {
    let time1 = a[orderBy] as unknown as string;
    let time2 = b[orderBy] as unknown as string;
    return compareTimes(time1, time2);
  }
  if (reportField !== 'imageCount' && reportField !== 'pibCount' && reportField !== 'numberOfOrders') {
    let field1 = a[orderBy] as unknown as string;
    let field2 = b[orderBy] as unknown as string;
    return field2.localeCompare(field1);
  }

  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function compareDates(
  firstStringDate: string,
  secondStringDate: string
): number {
  let date1 = 0;
  if (firstStringDate?.length > 0) {
    const firstDateSplit = firstStringDate.split('/');
    date1 = Number(firstDateSplit[2] + firstDateSplit[0] + firstDateSplit[1]);
  }

  let date2 = 0;
  if (secondStringDate?.length > 0) {
    const secondDateSplit = secondStringDate.split('/');
    date2 = Number(
      secondDateSplit[2] + secondDateSplit[0] + secondDateSplit[1]
    );
  }

  if (date1 < date2) {
    return 1;
  }
  if (date1 > date2) {
    return -1;
  }
  return 0;
}

export function compareTimes(
  first: string,
  second: string
): number {

  const firstTime = first.trim().length > 0 ? moment(first, 'h:mm a'): moment('12:00 AM', 'hh:mm a');
  const secondTime = second.trim().length > 0 ? moment(second, 'h:mm a'): moment('12:00 AM', 'hh:mm a');
  if (firstTime < secondTime) {
    return 1;
  } else if (firstTime > secondTime) {
    return -1;
  } else {
    return 0;
  }
}
